import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_IE_UQ || "uq.ie.styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_IE_UQ || 24275,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_IE_UQ || 24276,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_EU_UQ ||
    "1:160978693362:web:e3ce0b06e5d443cc47346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-2SB8ZPM5X6" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: false,
  showDualPrice: true,
  languages: [LANGUAGE.EN]
};

export default _countryEnv;
